module.exports = __webpack_public_path__ + "img/logo_secondary-black.871419df.svg";